import { apiSlice } from "../../api/apiSlice";

export const pointsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPoints: builder.query({
      query: () => "/api/user/points/stats",
      method: "GET",
      providesTags: ["Points"],
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetPointsQuery } = pointsApiSlice;
